import React from 'react';

/**
 * Progress Steps Component
 * Zobrazuje step-by-step progress během zpracování dotazu
 */
export default function ProgressSteps({ currentStep, onCancel }) {
  const steps = [
    { id: 1, label: 'Připojuji se k GA4...', duration: 2 },
    { id: 2, label: 'Získávám data...', duration: 3 },
    { id: 3, label: 'AI analyzuje výsledky...', duration: 4 },
    { id: 4, label: 'Hotovo!', duration: 1 }
  ];

  // Calculate estimated time remaining
  const estimateTimeRemaining = () => {
    if (currentStep >= steps.length) return 0;
    return steps.slice(currentStep).reduce((sum, step) => sum + step.duration, 0);
  };

  const timeRemaining = estimateTimeRemaining();
  const progress = (currentStep / steps.length) * 100;

  return (
    <div className="p-4 rounded-lg rounded-tl-none bg-gradient-to-r from-primary to-purple-600 text-white">
      {/* Header */}
      <div className="flex justify-between items-center mb-3">
        <span className="text-sm font-semibold">
          Zpracovávám váš dotaz...
        </span>
        {timeRemaining > 0 && (
          <span className="text-xs opacity-90">
            ~{timeRemaining}s zbývá
          </span>
        )}
      </div>

      {/* Progress Bar */}
      <div className="h-1.5 bg-white/30 rounded-full overflow-hidden mb-4">
        <div
          className="h-full bg-white transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Steps */}
      <div className="space-y-2.5">
        {steps.map((step) => {
          const isCompleted = step.id < currentStep;
          const isActive = step.id === currentStep;
          const isPending = step.id > currentStep;

          return (
            <div
              key={step.id}
              className="flex items-center gap-3 transition-all duration-300"
            >
              {/* Icon */}
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                  isCompleted
                    ? 'bg-green-400 text-white'
                    : isActive
                      ? 'bg-white text-primary animate-pulse'
                      : 'bg-white/30 text-white/70'
                }`}
              >
                {isCompleted ? (
                  <span className="material-symbols-outlined text-sm">check</span>
                ) : isActive ? (
                  <span className="material-symbols-outlined text-sm">radio_button_checked</span>
                ) : (
                  <span className="material-symbols-outlined text-sm">radio_button_unchecked</span>
                )}
              </div>

              {/* Label */}
              <span
                className={`text-sm flex-1 ${
                  isCompleted
                    ? 'opacity-80'
                    : isActive
                      ? 'font-semibold'
                      : 'opacity-60'
                }`}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>

      {/* Cancel Button */}
      {onCancel && currentStep < steps.length && (
        <button
          onClick={onCancel}
          className="mt-4 w-full px-4 py-2 bg-white/20 text-white border border-white/50 rounded-lg hover:bg-white/30 transition-colors text-sm font-semibold flex items-center justify-center gap-2"
        >
          <span className="material-symbols-outlined text-sm">close</span>
          Zrušit
        </button>
      )}
    </div>
  );
}
